import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Check if user has access to specific content
 * Returns access status, type, and pricing information
 * Used by profile UI to show paywall or content
 */
export const checkContentAccessRpcContract = rpcContract({
  name: "check-content-access",
  paramsSchema: v.object({
    contentType: v.picklist(["post", "link"]),
    contentId: v.string(),
  }),
  resultSchema: v.object({
    hasAccess: v.boolean(),
    accessType: v.optional(v.picklist(["subscription", "one_time_purchase", "owner"])),
    requiresSubscription: v.boolean(),
    oneTimePurchaseAvailable: v.boolean(),
    pricing: v.optional(
      v.object({
        subscriptionCents: v.optional(v.number()),
        oneTimeCents: v.optional(v.number()),
      }),
    ),
  }),
});

export type CheckContentAccessParams = v.InferOutput<(typeof checkContentAccessRpcContract)["paramsSchema"]>;
export type CheckContentAccessResult = v.InferOutput<(typeof checkContentAccessRpcContract)["resultSchema"]>;
